<template>
  <div style="position: relative">
    <div class="center-text">
      <div class="percent">{{percent}}%</div>
      <div style="font-size: 12px">COMPLETE</div>
    </div>
    <doughnut style="height: 100%; width: 100%" :chartData="chartdata" :options="opts" />
  </div>
</template>

<script>
import  Doughnut from "@/components/charts/doughnut/doughnut"

export default {
  components: { Doughnut },
  props: ['percent'],
  computed: {
    chartdata() {
       console.log(this.percent)
       return {
          datasets: [
            {
                data: [this.percent, 100 - this.percent],
                backgroundColor: [
                    "white",
                    "rgba(255,255,255,.4)"
                    // "rgba(0,0,0,.5)"
                ],
                hoverBackgroundColor: [
                    "white",
                    "rgba(0, 0, 0, 0)"
                ],
                borderWidth: [
                    0, 0
                ]
            }],
      } 
    }
  },
  data() {
    return {
          opts: {
            responsive:true,
    maintainAspectRatio: false,
            cutoutPercentage: 75,
            animation: {
                animationRotate: true,
                duration: 2000
            },
            legend: {
                display: false
            },
            tooltips: {
                enabled: false
            }
        }
    }
  },
}
</script>

<style lang="less" scoped>
.center-text {    
  position: absolute;
    top: 35%;
    left: 39%;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
  
  .percent {
    font-size: 25px;
  }
}

</style>
